export default __webpack_public_path__ + "static/works_2-36764ac51b7a15c54710c348f6383fb7.png";